import { Domain } from '../domains/domain';

export class Task {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
